export enum AppMode {
  Dev = 'development',
  Qa = 'qa',
  Prod = 'production',
}
